import React from "react";
import { motion } from "framer-motion";
import { SKILL_GROUPS } from "../lib/data";

export const Skills = () => {
  return (
    <section id="skills" data-testid="skills-section" className="py-24 md:py-32 bg-secondary/40 border-t border-black/5">
      <div className="max-w-6xl mx-auto px-6">
        <p className="overline text-primary mb-4">Skills & Tools</p>
        <h2 className="font-serif text-3xl md:text-5xl text-foreground mb-14 max-w-2xl leading-tight">
          A full-stack designer&apos;s toolkit.
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SKILL_GROUPS.map((group, i) => (
            <motion.div
              key={group.title}
              data-testid="skill-group"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
              className="rounded-2xl border border-black/5 bg-white p-6 card-shadow"
            >
              <h3 className="font-serif text-xl text-foreground mb-4">{group.title}</h3>
              <div className="flex flex-wrap gap-2">
                {group.items.map((item) => (
                  <span
                    key={item}
                    className="rounded-full bg-secondary text-secondary-foreground font-mono text-[11px] px-3 py-1.5 border border-black/5"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
